import React from "react";
import { Link } from "react-router-dom";
// import {reviewIcon } from "../Common/SvgIcon";
import { UserOutlined } from '@ant-design/icons';
import { Avatar, Space } from 'antd';
import { useQueryClient } from "@tanstack/react-query";
import { updateTapCount } from "../../../helpers/tapCountMutation";
function GridReview({ review, preview,Textcolor,Iconcolor }) {

  const reviewIcon = (
    <Space direction="vertical" size={16}>
    <Space wrap size={16}>
    <Avatar icon={<UserOutlined />} />
    </Space>
    
  </Space>
    
  );

  /* ------------------ tap count taking using tanstack query ----------------- */

  const queryClient = useQueryClient();

  const handleTap = (button, id) => {
      // console.log("iiii", id);

      updateTapCount(queryClient, button, id);
  };

  return (
    <div className="grid grid-cols-2 gap-3 items-center p-2">
      {review.map((reviewDetails, index) => {
        return reviewDetails?.reviewName ? (
          <Link
          onClick={() => handleTap('reviews', review._id)}
            to={`${preview ? reviewDetails?.reviewUrl : ""}`}
            target={`${preview ? "_blank" : ""}`}
          >
            <div className="max-w-[197px] h-[139px] border-[#F2F2F2] border rounded-[8px] items-center p-8" style={{background: `${Iconcolor ? Iconcolor : "black"}`}}>
              <div className="flex items-center justify-center h-[54px]">
                {reviewIcon}
              </div>

              <p className="text-[12px]  font-medium text-center" style={{color: `${Textcolor ? Textcolor : "black"}`}}>
                {reviewDetails.reviewName}
              </p>
            </div>
          </Link>
        ) : (
          ""
        );
      })}
    </div>
  );
}

export default GridReview;
